import Size from "../data/Size";
import UIFlex, { copyFlex, IFlex, IUIFlexProps } from "./UIFlex";
import UIIcon from "./UIIcon";
import './UIToggleButton.scss';


interface IUIToggleButtonProps extends IUIFlexProps{
    name:string;
    enabled:boolean;
    size?:string;
    yesLabel?:string;
    noLabel?:string;
    flex?:IFlex;
    fontSize?:string;
    dragFontSize?:string;
    dragWidth?:number;
    onChange?:($value:boolean, $name:string)=>void;
}


export default function UIToggleButton($props:IUIToggleButtonProps){

    let cn:string = "toggleButton";
    cn = Size.addSize(cn,$props.size);

    let cnDrag:string = "drag";
    cnDrag = Size.addFontSize(cnDrag,$props.dragFontSize || Size.s30);
    
    if($props.fontSize) cn = Size.addFontSize(cn,$props.fontSize);
    if($props.enabled) cn+=" enabled";
    
    let yesLabel:string = $props.yesLabel || "ON";
    let noLabel:string = $props.noLabel || "OFF";

    const flex = $props.flex?copyFlex({inline:true},$props.flex):{inline:true};

    return(
        <UIFlex 
            className={cn} 
            onClick={()=>{
                if($props.onChange){
                    $props.onChange(!$props.enabled,$props.name);
                }
            }}
            flex={flex}
        >
            <div className="inside">
                <div className="yesLabel">
                    {yesLabel}
                </div>
                <div className={cnDrag} style={{width:$props.dragWidth}}>
                    <UIIcon icon={UIIcon.DRAG_VERTICAL}/>
                </div>
                <div className="noLabel">
                    {noLabel}
                </div>
            </div>
        </UIFlex>
    );
}